/** @format */

import React, { useMemo, useState } from 'react';

import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import Button from '../../components/CustomButtons/ButtonExt';

import I18n from '../../components/Translate/I18n';
import CertificationRequestInterface from '../../interfaces/platform/CertificationRequestInterface';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { CertificationRequestState } from '../../helpers/CertificationRequestState';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { platformUserConstants } from '../../modules/platformuser/actions';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';

const CertificationRequest = (props: { request: CertificationRequestInterface }): React.ReactElement => {
    const request = props.request;
    const dispatch = useDispatch();
    const [downloaded, setDownloaded] = useState<boolean>(false);
    const statesList = useMemo(() => {
        return new CertificationRequestState();
    }, []);

    const downloadCert = (): void => {
        const linkSource = `data:application/pkcs12;base64,${request.certificationFile}`;
        const downloadLink = document.createElement('a');
        const fileName = 'certyfikat.p12';

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.putWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/certification_requests/download/' + request.id)),
            platformUserConstants.DELETE,
            {},
            (data: any) => {
                setDownloaded(true);
            },
            { dispatchAfterCallback: false, dispatchErrorAfterCallback: false, propagateDataToCallback: false }
        );
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <I18n trans={'auth:certificate.last_certificate_request'} />
            </GridItem>
            <GridItem xs={12}> </GridItem>
            <GridItem xs={6} style={{ textAlign: 'left' }}>
                <I18n trans={'auth:certificate.date'} />:
            </GridItem>
            <GridItem xs={6}>{DateHelperTs.format(request.requestedAt)}</GridItem>
            <GridItem xs={6} style={{ textAlign: 'left' }}>
                <I18n trans={'auth:certificate.accepted'} />:
            </GridItem>
            <GridItem xs={6}>{request.approved ? 'Tak' : 'Nie'}</GridItem>
            <GridItem xs={6} style={{ textAlign: 'left' }}>
                <I18n trans={'auth:certificate.state'} />
            </GridItem>
            <GridItem xs={6}>
                <I18n trans={statesList.getI18NForInt(request.state)} />
            </GridItem>
            {request.certificationFile && !downloaded && (
                <>
                    <br />
                    <br />
                    <GridItem xs={12} style={{ textAlign: 'center' }}>
                        <I18n trans={'auth:certificate.generated'} />:
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomTextButtom
                            callback={downloadCert}
                            callbackParam={{}}
                            size={'lg'}
                            color={'primary'}
                            label={'auth:certificate.download_certificate'}
                        />
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

export default CertificationRequest;
